import {Field, FieldsManager} from "../../../../data/services/fields";
import ResourceTable from "../../../../common/components/resource-table";
import useQueryNew from "../../../../hooks/use-query-new";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getResource} from "../../../../data/actions/resource";
import LocalStorage from "../../../../util/localStorage";
import {
    getDefaultTableOptions,
    getDefaultTableOptionsJSON, getLookup, getProp,
    saveTableColumns
} from "../../../../common/util/util-helpers";
import TableCard from "../../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../../common/components/resource-table/table-components/table-filters";
import {checkPerm, getUser, updateQuery} from "../../../../util/util";
import NoRecordsTable from "../../../../common/components/no-records-found/no-records-table";
import {download} from "../../../../data/actions/download";
import {currentDate} from "../../../../common/util/util-dates";
import DocumentArrowDownIcon from "@heroicons/react/20/solid/DocumentArrowDownIcon";
import Tippy from "@tippyjs/react";
import TableSettingsPopOver from "../../../../common/components/resource-table/table-components/table-settings-popover";
import TableOptionsDialog from "../../../../common/components/resource-table/table-components/table-options-dialog";
import {cloneDeep, genericMoneyFormatter} from "../../../../common/util/util-vanilla";
import PayDateFilter from "../../../accounting/carrier-pay/carrier-pay-date-filter";
import {fillFieldsFromData} from "../../../../common/util/util-fields";
import ResourceTableTopBar from "../../../../common/components/resource-table/table-components/resource-table-top-bar";
import FieldSearch from "../../../../common/components/fields/field-text/search";
import TableCardFooter from "../../../../common/components/resource-table/table-components/table-card-footer";
import Pagination from "../../../../common/components/resource-table/table-components/pagination";
import ModalDefault from "../../../../common/components/modal/modal-default";
import CellLink from "../../../../common/components/resource-table/table-components/cell-link";
import Resources from "../../../../data/services/resources";
import {UPDATE_PERM} from "../../../../util/util-constants";
import WorkOrderStatusBadge from "../../../../common/components/badge/work-order-status-badge";
import {getSecondResource} from "../../../../data/actions/secondResource";
import ActiveFilters from "../../../../common/components/resource-table/table-components/active-filters";

export default function WorkOrdersReportsTab({additionalQuery, resourcePath, storagePath, selects = {}, getFields, tableKey, translate}) {
    const dispatch = useDispatch();
    const [queryFields, setQueryFields] = useQueryNew(getQueryFields(), storagePath);
    const [queryWoFields, setQueryWoFields] = useQueryNew(getQueryWoFields(), storagePath);

    const [tableOptions, setTableOptions] = useState(getTableOptions(storagePath, translate))

    const [isColumnsDialogVisible, setIsColumnsDialogVisible] = useState(false)

    const resource = useSelector(state => state.resource);
    const secondResource = useSelector(state => state.secondResource);
    const data = resource?.data?.list ?? [];
    const isLoading = resource.isLoading ?? false;
    const secondData = getProp(secondResource, 'data.list', [])
    const secondCount = getProp(secondResource, 'data.count', 0)
    const secondIsLoading = getProp(secondResource, 'isLoading', false)

    const [showWoDialog, setShowWoDialog] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});

    const fetchSecondData = useCallback(() => {
        if (selectedItem?.TruckID || selectedItem?.TrailerID) {
            dispatch(getSecondResource({
                user: getUser(),
                query: Object.assign({}, {}, FieldsManager.getFieldKeyValues(queryWoFields), {searchFields: JSON.stringify(Object.assign({}, selectedItem?.TruckID ? {TruckID: selectedItem?.TruckID} : {TrailerID: selectedItem?.TrailerID}, {...(!!queryFields?.StartDate && {StartDate: ['RequestDate', '>=', queryFields?.StartDate.value]}), ...(!!queryFields?.EndDate.value && {EndDate: ['RequestDate', '<=', queryFields?.EndDate.value]})}))}),
                resource: Resources.WorkOrders
            }));
        }
    },[queryWoFields, selectedItem])

    function getFieldsWo(item = {}) {

        const fieldTemplates = {
            AutoCounter: new Field('AutoCounter', '', [''], false, 'custom', {
                render: (it) => {
                    return (
                        <CellLink
                            openInNewTab={true}
                            to={checkPerm(Resources.WorkOrders, UPDATE_PERM) && "/work-orders/" + it.WorkOrderID}
                            disabled={!checkPerm(Resources.WorkOrders, UPDATE_PERM)}
                        >
                            {it.AutoCounter}
                        </CellLink>
                    )
                }
            }),
            WorkOrderStatusID: new Field('WorkOrderStatusID', '', [''], false, 'select', {
                render: (it) => <WorkOrderStatusBadge
                    workOrderStatuses={getLookup("WorkOrderStatus") ?? {}}
                    statusID={it.WorkOrderStatusID}
                />
            }),
            TruckID: new Field('TruckID', '', ['empty'], false, 'select-search', {addContainerClass: 'col-span-full'}),
            TrailerID: new Field('TrailerID', '', [''], false, 'select-search', {addContainerClass: 'col-span-full'}),
            TotalAmount: new Field('TotalAmount', '', [''], false, "float", {
                render: (it) => (
                    <Tippy
                        content={
                            <div className={"text-right"}>
                                <div>Labor: {genericMoneyFormatter(it.LaborAmount)}</div>
                                <div>Parts: {genericMoneyFormatter(it.PartsAmount)}</div>
                                <div>Shop supplies: {genericMoneyFormatter(it.MiscAmount)}</div>
                                <div>Misc. surcharge: {genericMoneyFormatter(it.SurchargeAmount)}</div>
                            </div>
                        }
                    >
                        <div className={"text-right"}>
                            {genericMoneyFormatter(it.TotalAmount)}
                        </div>
                    </Tippy>
                ),
                colFilter: true
            }, {icon: false}),
            CreatedDate: new Field('CreatedDate', '', [''], false, 'datetimezone'),
            CreateUpdateDate: new Field('CreateUpdateDate', '', [], false, 'datetimezone'),
            UpdatedByContactID: new Field('UpdatedByContactID', '', [], false, 'select-search'),
            CreatedByID: new Field('CreatedByID', '', [''], false, 'select-search', {})
        }

        return fillFieldsFromData(fieldTemplates, item)
    }

    const handleTruckWoClick = (item) => {
        setShowWoDialog(!showWoDialog);
        setSelectedItem(item);
        fetchSecondData();
        setQueryWoFields(getQueryWoFields());
    }
    const handleTrailerWoClick = (item) => {
        setShowWoDialog(!showWoDialog);
        setSelectedItem(item);
        fetchSecondData();
        setQueryWoFields(getQueryWoFields());
    }

    const fetchData = useCallback(() => {
        dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: resourcePath,
            query: FieldsManager.getFieldKeyValues(queryFields)
        }))
    }, [resourcePath, queryFields, dispatch]);

    const downloadExcel = () => {
        dispatch(download({
            user: LocalStorage.get('user'),
            resource: resourcePath,
            query: Object.assign({format: 'EXCEL', name: 'report_' + currentDate() + '.xlsx'},FieldsManager.getFieldKeyValues(queryFields))
        }))
    }

    function handleQueryChange(name, value) {
        let queryUpdate = updateQuery(queryFields, name, value);
        if (name === 'query') {
            queryUpdate.offset.value = "0"
        }

        if (name === 'limit') {
            queryUpdate.offset.value = "0"
        }

        setQueryFields(queryUpdate);
    }

    function handleQueryWoChange(name, value) {
        let queryUpdate = updateQuery(queryWoFields, name, value);
        if (name === 'query') {
            queryUpdate.offset.value = "0"
        }

        if (name === 'limit') {
            queryUpdate.offset.value = "0"
        }

        setQueryWoFields(queryUpdate);
    }

    function getQueryFields() {
        return Object.assign({
                query: new Field('query', '', [''], false, 'search', {hideLabel: true, labelType: "float"})
            },
            additionalQuery,
            {
                offset: new Field('offset', '0', [''], false, 'text'),
                sort: new Field('sort', 'ASC', [''], false, 'text'),
                sortBy: new Field('sortBy', tableKey, [''], false, 'text'),
                limit: new Field('limit', "10", [''], false, 'select', {
                    hideLabel: true,
                    labelType: "float"
                }, {menuPlacement: "top"})
            });
    }

    function getQueryWoFields() {
        return Object.assign({
                query: new Field('query', '', [''], false, 'search', {hideLabel: true, labelType: "float"}),
            },
            additionalQuery,
            {
                offset: new Field('offset', '0', [''], false, 'text'),
                sort: new Field('sort', 'ASC', [''], false, 'text'),
                sortBy: new Field('sortBy', tableKey, [''], false, 'text'),
                limit: new Field('limit', "10", [''], false, 'select', {
                    hideLabel: true,
                    labelType: "float"
                }, {menuPlacement: "top"})
            });
    }


    function getTableOptions(pagePath, translate) {
        const tablePageDefaults = {
            version: 1,
            behaviour: {
                canAdjustWidth: true,
                hasMenu: true
            },
            style: {
                condensed: true,
                isGPUAccelerated: true
            }
        }

        return getDefaultTableOptions(getFields(), tablePageDefaults, storagePath, translate);
    }

    const getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(getFields(),{
            behaviour: {
                canAdjustWidth: true,
                hasMenu: true
            },
            style: {
                condensed: true,
                isGPUAccelerated: true
            }
        } , translate)
    }

    const setOptions = (options) => {
        setTableOptions(options)
        saveTableColumns(storagePath, options)
    }

    function setTableColumnOptions(columns) {
        let tableOptionsUpdate = cloneDeep(tableOptions)

        tableOptionsUpdate.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        setTableOptions(tableOptionsUpdate)
        setIsColumnsDialogVisible(false)
        saveTableColumns(storagePath, tableOptionsUpdate)
    }

    const handleQueryInputChange = (name, value) => {
        setQueryFields(FieldsManager.updateField(queryFields, name, value));
    }

    const handleClearFiltersClick = (excludeAdditional = []) => {
        const queryFilterFieldsTmp = Object.assign({}, queryFields)
        const defaultExcludedFields = ['limit', 'sort', 'sortBy']
        const excludedFields = defaultExcludedFields.concat(excludeAdditional)

        Object.values(queryFilterFieldsTmp).filter((it) => !excludedFields.includes(it.name)).forEach((it) => {
            FieldsManager.updateField(queryFilterFieldsTmp, it.name, '')
        })

        setQueryFields(queryFilterFieldsTmp)
    }

    let PartsAmount = 0;
    let LaborAmount = 0;
    let OtherAmount = 0;
    let TotalAmount = 0;



    data.forEach(it => {
        PartsAmount = PartsAmount + it.PartsAmount;
        LaborAmount = LaborAmount + it.LaborAmount;
        OtherAmount = OtherAmount + it.OtherAmount;
        TotalAmount = TotalAmount + it.TotalAmount;
    });

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        fetchSecondData();
    }, [fetchSecondData]);

    return (
      <>
          <ActiveFilters
              filterFields={queryFields}
              onLabelClick={handleQueryInputChange}
              onClearFiltersClick={handleClearFiltersClick}
              translate={translate}
          />

        <TableCard>
            <div className="flex ml-auto">
                <div className={'flex mr-4'}>
                    <Tippy content={translate('text.download_excel')}>
                        <button
                            className="btn-icon"
                            onClick={downloadExcel}
                        >
                            <DocumentArrowDownIcon className="w-5 h-5"/>
                        </button>
                    </Tippy>

                    <div className={"ml-auto"}>
                        <TableSettingsPopOver
                            options={tableOptions}
                            setOptions={setOptions}
                            toggleColumnSettingsDialog={() => setIsColumnsDialogVisible(true)}
                            translate={translate}
                        />
                    </div>
                </div>
            </div>

            <TableFilters
                forceDialog
                hideLimit
                filterFields={queryFields}
                handleInputChange={handleQueryChange}
                translate={translate}
                onRefreshTable={fetchData}
                selects={selects}
                isLoading={isLoading}
                customHtml={
                    <PayDateFilter
                        queryFields={queryFields}
                        translate={translate}
                        updateQueryFields={(queryFieldsUpdate) => {
                            setQueryFields(queryFieldsUpdate);
                        }}
                        hasDateType={false}
                        onQueryChange={handleQueryInputChange}
                    />
            }
            />

                    <ResourceTable
                        tableKey={tableKey}
                        data={data}
                        fields={getFields()}
                        options={tableOptions}
                        isLoading={isLoading}
                        translate={translate}
                        queryFields={queryFields}
                        onSortChange={(fieldName) => handleQueryChange("sortBy", fieldName)}
                        saveTableOptions={setOptions}
                        maxHeightClass={"max-h-[calc(100vh-23rem)]"}
                        onRowClick={(it) => it?.TruckID ? handleTruckWoClick(it) : handleTrailerWoClick(it)}
                        tfoot={!!data.length && {
                            PartsAmount: PartsAmount,
                            LaborAmount: LaborAmount,
                            OtherAmount: OtherAmount,
                            TotalAmount: TotalAmount
                        }}
                    />

                    <NoRecordsTable
                        show={(data.length === 0) && !isLoading}
                        title={'No matching records found'}
                        className={"pb-12 pt-16 px-6"}
                    />

            <TableOptionsDialog
                show={isColumnsDialogVisible}
                pagePath={storagePath}
                columns={tableOptions.columns}
                setTableColumnOptions={setTableColumnOptions}
                getDefaultTableColumnOptions={getDefaultTableColumnOptions}
                onClose={() => setIsColumnsDialogVisible(false)}
                translate={translate}
            />

            <ModalDefault
                title={selectedItem?.Truck ? translate("title.work_orders_for_truck", [selectedItem?.Truck]) : translate("title.work_orders_for_trailer", [selectedItem?.Trailer])}
                show={showWoDialog}
                onClose={handleTruckWoClick}
                translate={translate}
                widthClass={"max-w-6xl"}
            >
                <div className="max-h-[calc(100vh-14rem)] overflow-auto">
                    <ResourceTableTopBar
                        addClass="rounded-t-md px-4"
                    >
                        <FieldSearch
                            addClass="form-control"
                            name="query"
                            value={queryWoFields?.query?.value}
                            onChange={handleQueryWoChange}
                            translate={translate}
                        />

                    </ResourceTableTopBar>

                    {(secondIsLoading || !!secondCount) && (
                        <ResourceTable
                            data={secondData}
                            fields={getFieldsWo()}
                            queryFields={queryWoFields}

                            options={{
                                style: {
                                    stripedRows: true,
                                    horizontalLines: true,
                                    verticalLines: true,
                                    floatingActions: true
                                }
                            }}

                            translate={translate}
                            isLoading={secondIsLoading}
                        />

                    )}


                        <NoRecordsTable
                            show={(secondData.length === 0) && !secondIsLoading}
                            title={'No matching records found'}
                            className={"pb-12 pt-16 px-6"}
                        />
                </div>
                <TableCardFooter
                    show={!(!secondData.length && !secondIsLoading)}
                >
                    <Pagination
                        count={secondCount}
                        isLoading={secondIsLoading}
                        handleQueryChange={handleQueryWoChange}
                        queryFields={queryWoFields}
                        translate={translate}
                    />
                </TableCardFooter>
            </ModalDefault>
        </TableCard>
      </>
);
}